import React from 'react';
import { Link } from 'react-router-dom';
import eventBg from "./../green-event-iq-logo.png";


export default function Header() {
  return (
    <header className="bg-[#103c2c] text-white shadow">
      <div className="max-w-7xl mx-auto px-4 py-3 sm:px-6 lg:px-8 flex items-center justify-between">
        {/* Logo / Brand */}
        <Link to="/" className="text-xl font-bold hover:opacity-90">
         
          <img className="w-[200px]" src={eventBg} alt="EventIQ logo" />
        </Link>

        {/* Navigation */}
        <nav className="space-x-4">
          {/* <Link to="/" className="hover:underline">
            Home
          </Link> */}
          {/* <Link to="/events" className="hover:underline">
            Events
          </Link> */}
          
          <Link to="/apps/eventiq/privacy" className="hover:underline">
            Privacy
          </Link>
           <Link to="/apps/eventiq/terms" className="hover:underline">
            Terms
          </Link>
          {/* Add more links as needed */}
        </nav>
      </div>
    </header>
  );
}
